import { render, staticRenderFns } from "./CombineLogo.vue?vue&type=template&id=9116c13a"
import script from "./CombineLogo.vue?vue&type=script&lang=js"
export * from "./CombineLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports